import * as React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import { FormattedNumber } from 'react-intl';
import { PaymentRecordDetail } from './Types';
import { BusinessState } from '../business/business.types';
import { M3 } from '../business/business.constants';
import ExtraCollectionChargeModal from './ExtraCollectionChargeModal';
import {
  DEFAULT_PAYMENT_SCHEDULED,
  NOT_REQUESTED,
  FAILED
} from './Constants';
import * as moment from 'moment';

type Props = {
  readonly businessState: BusinessState
  readonly paymentRecordDetail: PaymentRecordDetail
  readonly modalOpen: boolean
  readonly togglePaymentDetailsModalOpen: () => void
};

type States = {
  readonly extraCollectionChargeModalOpen: boolean
};

class PaymentsDetailsModal extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
      extraCollectionChargeModalOpen: false
    };
  }

  componentWillUnmount() {
    this.setState({
      extraCollectionChargeModalOpen: false
    });
  }

  render() {
    const { paymentRecordDetail, modalOpen } = this.props;

    return (
      <Dialog
        title="Payment Record Detail"
        actions={[
          this.renderCloseButton(),
          this.renderRequestCollection()
        ]}
        modal={true}
        open={modalOpen}
        contentStyle={{width: '85%', maxWidth: 'none'}}
        autoScrollBodyContent={true}
      >
        <div className="row mt-2 mb-2">
          <Table
            fixedHeader={true}
            fixedFooter={false}
            selectable={false}
            multiSelectable={false}
            style={{fontSize: 10}}
          >
            <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
              enableSelectAll={false}
            >
              <TableRow>
                <TableHeaderColumn tooltip="Collection Status">Collection Status</TableHeaderColumn>
                <TableHeaderColumn tooltip="Payer Name">Payer Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Amount">Amount</TableHeaderColumn>
                <TableHeaderColumn tooltip="Number of Transactions">Number of TXN</TableHeaderColumn>
                <TableHeaderColumn tooltip="Total">Total</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={false}
            >
              <TableRow>
                <TableRowColumn>
                  {paymentRecordDetail.collectionStatus ?
                    paymentRecordDetail.collectionStatus :
                    NOT_REQUESTED
                  }
                </TableRowColumn>
                <TableRowColumn>{paymentRecordDetail.payerName}</TableRowColumn>
                <TableRowColumn>
                  <FormattedNumber value={paymentRecordDetail.amount} style="currency" currency="USD" />
                </TableRowColumn>
                <TableRowColumn>{paymentRecordDetail.numberOfTransactions}</TableRowColumn>
                <TableRowColumn>
                  <FormattedNumber value={paymentRecordDetail.total} style="currency" currency="USD" />
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
          <Table
            fixedHeader={true}
            fixedFooter={false}
            selectable={false}
            multiSelectable={false}
            style={{fontSize: 10}}
          >
            <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
              enableSelectAll={false}
            >
              <TableRow>
                <TableHeaderColumn tooltip="Down Payment">Down Payment</TableHeaderColumn>
                <TableHeaderColumn tooltip="Payment Status">Payment Status</TableHeaderColumn>
                <TableHeaderColumn tooltip="Charge Date">Charge Date</TableHeaderColumn>
                <TableHeaderColumn tooltip="Remaining Transaction">RMNG TXN</TableHeaderColumn>
                <TableHeaderColumn tooltip="Remaining Balance">Remaining Balance</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={false}
            >
              <TableRow>
                <TableRowColumn>
                  <FormattedNumber value={paymentRecordDetail.downPayment} style="currency" currency="USD" />
                </TableRowColumn>
                <TableRowColumn>{paymentRecordDetail.paymentStatus}</TableRowColumn>
                <TableRowColumn>{moment(new Date(paymentRecordDetail.chargeDate)).format('MMM Do YY')}</TableRowColumn>
                <TableRowColumn>{paymentRecordDetail.remainingTransactions}</TableRowColumn>
                <TableRowColumn>
                  <FormattedNumber value={paymentRecordDetail.remainingBalance} style="currency" currency="USD" />
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
          <Table
            fixedHeader={true}
            fixedFooter={false}
            selectable={false}
            multiSelectable={false}
            style={{fontSize: 10}}
          >
            <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
              enableSelectAll={false}
            >
              <TableRow>
                <TableHeaderColumn tooltip="Description">Description</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={false}
            >
              <TableRow>
                <TableRowColumn>{paymentRecordDetail.description}</TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
          <ExtraCollectionChargeModal
            modalOpen={this.state.extraCollectionChargeModalOpen}
            toggleExtraCollectionChargeModalOpen={this.toggleExtraCollectionChargeModalOpen}
            togglePaymentDetailsModalOpen={this.props.togglePaymentDetailsModalOpen}
            paymentRecordDetail={this.props.paymentRecordDetail}
          />
        </div>
      </Dialog>
    );
  }

  private renderRequestCollection = (): JSX.Element => {
    const { paymentRecordDetail } = this.props;

    if (
      this.props.businessState.business &&
      this.props.businessState.business.servicePackage &&
      this.props.businessState.business.servicePackage === M3
    ) {
      return(
        <FlatButton
          label="Request Collection"
          primary={true}
          onClick={this.toggleExtraCollectionChargeModalOpen}
          disabled={
            paymentRecordDetail.paymentHistoryId === DEFAULT_PAYMENT_SCHEDULED ||
            paymentRecordDetail.paymentStatus !==  FAILED ||
            (paymentRecordDetail.collectionStatus &&  paymentRecordDetail.collectionStatus !== NOT_REQUESTED)
          }
        />
      );
    } else {
      return(null);
    }
  }

  private renderCloseButton = (): JSX.Element => {
    return(
      <FlatButton label="Close" primary={true} onClick={this.props.togglePaymentDetailsModalOpen}/>
    );
  }

  private toggleExtraCollectionChargeModalOpen = (): void =>
    this.setState({extraCollectionChargeModalOpen: !this.state.extraCollectionChargeModalOpen})
}

export default PaymentsDetailsModal;



// WEBPACK FOOTER //
// ./src/payments/paymentsDetailsModal.tsx